import { Alert, AlertIcon, Stack, Text } from "@chakra-ui/react";
import { useAuth } from "../../features/auth/hooks/useAuth";
import SubscribeButton from "../../features/assinatura/components/SubscribeButton";

// Aviso do plano da conta (ADR 0010). `plan` vem calculado pelo backend (GET /api/v1/me):
// trial | subscriber | free | read_only. Depois dos 14 dias de teste, sem assinatura, a
// conta continua no plano grátis com 1 vínculo; com mais vínculos fica só leitura, e toda
// gravação responde 402 com a mesma explicação.
export default function TrialBanner() {
  const { user } = useAuth();

  if (!user) {
    return null;
  }

  // `=== false` (e não `!`) para não acusar conta só leitura se a API ainda não devolver
  // o campo (ex.: frontend novo com backend antigo durante o deploy).
  if (user.plan === "read_only" || user.has_access === false) {
    // Ex-assinante (subscription_ends_at preenchido, mas vencido) não está saindo de um
    // teste — o aviso fala da assinatura.
    const fim = user.subscription_ends_at ? "Sua assinatura terminou" : "Seu período de teste terminou";
    return (
      <PlanAlert status="warning">
        {fim} e o plano grátis comporta 1 vínculo. Seus dados continuam disponíveis para
        consulta; assine ou exclua vínculos até sobrar 1 para voltar a registrar e editar.
      </PlanAlert>
    );
  }

  if (user.plan === "free") {
    return (
      <PlanAlert status="info">
        Você está no plano grátis: 1 vínculo, com plantões e comprovações ilimitados. Assine para
        cadastrar outros vínculos.
      </PlanAlert>
    );
  }

  // Assinante (ou admin) não vê contagem regressiva do trial. Sem `plan` (backend antigo),
  // só uma assinatura ainda vigente esconde a contagem — uma já vencida não esconde a de
  // um trial que o admin estendeu.
  const assinaturaVigente =
    user.subscription_ends_at && new Date(user.subscription_ends_at) > new Date();
  if (user.plan === "subscriber" || (!user.plan && assinaturaVigente)) {
    return null;
  }

  if (user.trial_days_remaining <= 3) {
    const dia = user.trial_days_remaining === 1 ? "dia" : "dias";
    return (
      <PlanAlert status="info">
        Seu período de teste termina em {user.trial_days_remaining} {dia}. Depois dele, o plano
        grátis continua com 1 vínculo; assine para manter todos.
      </PlanAlert>
    );
  }

  return null;
}

function PlanAlert({ status, children }) {
  return (
    <Alert status={status} justifyContent="center">
      <AlertIcon />
      <Stack direction={{ base: "column", md: "row" }} align="center" spacing={3}>
        <Text fontSize="sm">{children}</Text>
        <SubscribeButton origin="banner" />
      </Stack>
    </Alert>
  );
}
